/**
 * ga4タグ発火
 * @param {*} event イベント名
 * @param {*} category カテゴリー
 * @param {*} label ラベル
 */
export default (options) => {
  // gaタグ
  setGaTag(options);
};

const setGaTag = ({ event, category, label }) => {
  gtag('event', event, {
    event_category: category,
    event_label: label,
    send_to: import.meta.env.VITE_APP_GAID,
  });
};
